import SEOArticleLayout from "@/components/feature/SEOArticleLayout";

const IMAGE = "https://readdy.ai/api/search-image?query=Step%20by%20step%20workflow%20diagram%20on%20whiteboard%20next%20to%20desk%20with%20tablet%20displaying%20data%20charts%2C%20modern%20creative%20office%20space%2C%20warm%20natural%20light%2C%20clean%20minimal%20interior%2C%20cream%20and%20warm%20wood%20tones%2C%20productive%20atmosphere&width=900&height=1100&seq=seo-article-fonctionne-v3&orientation=portrait";

export default function CommentCaFonctionnePage() {
  return (
    <SEOArticleLayout
      title="Comment fonctionne le Hipobuy Spreadsheet ?"
      subtitle="Un guide détaillé du fonctionnement du hipobuy spreadsheet, de la configuration initiale à l'optimisation avancée de votre suivi e-commerce."
      heroImageUrl={IMAGE}
      heroImageAlt="Comment fonctionne Hipobuy Spreadsheet"
    >
      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Le principe de fonctionnement</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Le <strong>hipobuy spreadsheet</strong> fonctionne sur un principe simple mais efficace : collecter automatiquement les données de vos produits depuis vos plateformes de vente, les analyser en temps réel, puis vous présenter des insights actionnables. Tout cela dans une interface qui ressemble à un tableur, mais avec une intelligence intégrée.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Étapes de fonctionnement</h2>
        <div className="space-y-4">
          {[
            { title: "1. Connexion des plateformes", desc: "Vous connectez vos comptes Shopify, Amazon ou vos flux dropshipping au hipobuy spreadsheet. L'outil importe automatiquement votre catalogue produits." },
            { title: "2. Collecte automatique des données", desc: "Le hipobuy spreadsheet surveille en continu les prix, stocks et performances de chaque produit. Les mises à jour sont automatiques." },
            { title: "3. Analyse concurrentielle", desc: "L'outil compare vos prix avec ceux du marché et vous alerte des opportunités ou des risques. Une veille concurrentielle sans effort." },
            { title: "4. Recommandations intelligentes", desc: "Basé sur les données collectées, le hipobuy spreadsheet vous suggère les actions à mener : ajuster un prix, réapprovisionner un produit, etc." },
            { title: "5. Suivi des résultats", desc: "Des tableaux de bord visuels vous montrent l'évolution de vos KPIs. Vous voyez immédiatement l'impact de vos décisions." },
          ].map((step, i) => (
            <div key={i} className="flex gap-3 p-4 bg-background-100 rounded-2xl">
              <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <span className="text-primary-700 text-sm font-bold">{i + 1}</span>
              </div>
              <div>
                <h4 className="font-heading text-base font-semibold text-foreground-950 mb-1">{step.title}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Pourquoi ce fonctionnement change tout</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Là où un tableur classique vous oblige à tout faire manuellement, le <strong>hipobuy spreadsheet</strong> automatise l'ensemble du processus. Vous passez de « subir les données » à « piloter votre business ». Le temps gagné peut être réinvesti dans la stratégie, le marketing ou le développement de nouveaux produits.
        </p>
      </section>

      <div className="mt-8 p-6 bg-accent-50 rounded-2xl border border-accent-100 text-center">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">Prêt à automatiser votre suivi ?</h3>
        <p className="text-sm text-foreground-500 mb-4">Testez le fonctionnement du hipobuy spreadsheet par vous-même.</p>
        <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer">
          Accéder à la Plateforme
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </SEOArticleLayout>
  );
}